import { FulfillmentOrderAddressWithIdSchema } from "@redotech/redo-model/fulfillments/fulfillment-order-address";
import * as z from "zod/v4";
import { null as zNull } from "zod/v4";
export const getReturnAddresses = {
  name: "getReturnAddresses" as const,
  input: zNull(),
  output: z.object({ addresses: z.array(FulfillmentOrderAddressWithIdSchema) }),
};
